import { Client, PaginatedResponse } from 'src/api/Client';
import { CommentResponse, StoreCommentRequest } from './CommentClient.types';
import { ApiQueryObject } from 'src/lib/services/api-query-params';
import { AxiosRequestConfig } from 'axios';

class CommentClient extends Client {
  public readonly route = {
    filterRequestComments: `${this.http.baseUrl}/comments/{model}/filter`,
    store: `${this.http.baseUrl}/comments/{model}`,
    delete: `${this.http.baseUrl}/comments/{model}`,
  };

  filterRequestComments = (
    model: string,
    params: ApiQueryObject & { from_revision?: string },
    config?: AxiosRequestConfig,
  ): Promise<PaginatedResponse<CommentResponse>> => {
    return this.http.get(this.buildUrl(this.route.filterRequestComments, { model }), {
      ...(config ?? {}),
      params,
    });
  };

  store = (model: string, data: StoreCommentRequest): Promise<CommentResponse> => {
    return this.http.post(this.buildUrl(this.route.store, { model }), data);
  };

  delete = (model: string): Promise<void> => {
    return this.http.delete(this.buildUrl(this.route.delete, { model }));
  };
}

export default CommentClient;
